import { ArrowUpOnSquareStackIcon } from "@heroicons/react/24/outline";

export function FileUpIcon({ className }: { className?: string }) {
  return <ArrowUpOnSquareStackIcon className={className} />;
}
